import {
  type PersonaListSnapshot,
  type PersonaListStateDeps,
  normalizeDesktopShowRows,
  peekExpectRestore,
  hasListSnapshot,
  clearListRestoreState,
  saveListSnapshot,
  parseListSnapshot,
  leavePersonaListState,
} from '../shared/list-state-storage.base';

export { type PersonaListTab as GatehouseSchedulerTab } from '../shared/list-state-storage.base';

export const GATEHOUSE_LIST_SNAPSHOT_KEY = 'dgag_gatehouse_list_snapshot';
export const GATEHOUSE_EXPECT_RESTORE_KEY = 'dgag_gatehouse_expect_restore';

export type GatehouseListSnapshot = PersonaListSnapshot;
export type LeaveGatehousePersonaListStateDeps = PersonaListStateDeps;

export function normalizeGatehouseDesktopShowRows(size: number): number {
  return normalizeDesktopShowRows(size);
}

export function peekExpectGatehouseRestore(): boolean {
  return peekExpectRestore(GATEHOUSE_EXPECT_RESTORE_KEY);
}

export function hasGatehouseListSnapshot(): boolean {
  return hasListSnapshot(GATEHOUSE_LIST_SNAPSHOT_KEY);
}

export function clearGatehouseListRestoreState(): void {
  clearListRestoreState(GATEHOUSE_LIST_SNAPSHOT_KEY, GATEHOUSE_EXPECT_RESTORE_KEY);
}

export function saveGatehouseListSnapshot(snapshot: GatehouseListSnapshot): void {
  saveListSnapshot(GATEHOUSE_LIST_SNAPSHOT_KEY, snapshot);
}

export function parseGatehouseListSnapshot(): GatehouseListSnapshot | null {
  return parseListSnapshot(GATEHOUSE_LIST_SNAPSHOT_KEY);
}

export function leaveGatehousePersonaListState(deps: LeaveGatehousePersonaListStateDeps): void {
  leavePersonaListState(deps, GATEHOUSE_LIST_SNAPSHOT_KEY, GATEHOUSE_EXPECT_RESTORE_KEY, '/gatehouse');
}
